import {
    POST,
    GET
} from "../util";
const dashboardBaseUrl = "api/dashboard-inspection/";
const dataSeller = `${dashboardBaseUrl}data-seller/`
const dataBuyer = `${dashboardBaseUrl}data-buyer/`
    // /api/currency/list

const url = {
    seller: {
        currencies: `${dataSeller}currencies`,
        years: `${dataSeller}years`,
    },
    buyer: {
        accounts: `${dataBuyer}accounts`,
        years: `${dataBuyer}years`,
    }
};
const dashboardInspectionApi = {
    seller: {
        currencies: () => {
            return GET(url.seller.currencies);
        },
        years: () => {
            return GET(url.seller.years);
        },
        allInfo: (currency, year) => {
            return GET(dataSeller + currency + '/' + year, );
        },
    },
    buyer: {
        accounts: () => {
            return GET(url.buyer.accounts);
        },
        years: () => {
            return GET(url.buyer.years);
        },
        allInfo: (accountId, year) => {
            return GET(dataBuyer + accountId + '/' + year, );
        },
    }

};
export {
    dashboardInspectionApi
};